<template>
  <button
    :key="item.type"
    class="relative flex flex-row items-center gap-8 py-8 px-16 w-full bg-bg-base text-text-subtle type-sm hover:bg-bg-subtle hover:text-text-base mobOnly:hover:bg-bg-base"
    :class="{
      selected: selected === item.type,
      'text-darkest font-medium': selected === item.type,
      'hidden': (onlySelected && selected !== item.type) || item.desktopOnly,
    }"
    type="button"
  >
    <img
      :src="selected === item.type ? item.activeIcon : item.icon"
      class="w-20 h-20"
      alt=""
    >
    <div
      class="flex-1 text-left"
      :class="{ 'hidden deskStd:block': item.langKeyMobile }"
    >
      {{ $t(item.langKey) }}
    </div>
    <div v-if="item.langKeyMobile" class="deskStd:hidden">
      {{ $t(item.langKeyMobile) }}
    </div>
    <div
      v-if="item.notificationKey && userStore.getNotificationByType(item.notificationKey).length"
      class="absolute top-8 right-8 tabletPortrait:relative tabletPortrait:top-0 tabletPortrait:right-0
                flex justify-center items-center bg-bg-error type-headline-xs leading-single text-text-error
                w-20 h-20 desk:w-24 desk:h-24"
    >
      {{ userStore.getNotificationByType(item.notificationKey).length }}
    </div>
  </button>
</template>

<script setup lang="ts">
import { useUserStore } from '~/store/user';
import type { NavigationItem } from '~/composables/useMyPageNavigation';

const userStore = useUserStore();

defineProps<{
  item: NavigationItem,
  selected: string,
  onlySelected: boolean,
}>();

</script>
